export const addHttpsProtocolToUrl = (url: string) =>
  url.replace(/^(http(s)?:\/\/)?/i, () => "https://");
